import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="landing-page">
      <div className="landing-background">
        <div className="particles"></div>
        <div className="particles"></div>
        <div className="particles"></div>
      </div>

      <div className="landing-content">
        <div className="landing-logo-section">
          <div className="landing-logo-container">
            <img 
              src="/fortuin.gif" 
              alt="Escape Room Logo" 
              className="landing-logo-gif"
            />
          </div>
          <h1 className="landing-title">Escape Room</h1>
          <p className="landing-subtitle">Het Fortuin van Valmont</p>
        </div>

        
        

        <div className="landing-actions">
          <button 
            onClick={handleLogin}
            className="btn-landing-login"
          >
            <span className="btn-text">Go to Gamemaster Login</span>
            <span className="btn-arrow">→</span>
          </button>
        </div>

        
      </div>
    </div>
  );
}

export default LandingPage;

